import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { useState } from "react";
import PATH from "../../router/params";
import { Menu, MenuItem, styled } from "@mui/material";
import { AccountCircle } from "@mui/icons-material";

const drawerWidth = 240;

const MainLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [auth, setAuth] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };
  const handleChange = (event) => {
    setAuth(event.target.checked);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate(PATH.LOGIN, { replace: true });
  }
  const CustomDivider = styled(Divider)(({ theme }) => ({
    backgroundColor: `${theme.palette.gray.main} !important`,
    // marginTop:"2rem"
  }));

  const drawer = (
    <div>
      <Box
        sx={{
          display: "flex",
          minHeight: "64px",
          width: "100%",
          justifyContent: "flex-start",
          alignItems: "center",
          pl: "16px",
        }}
      >
        <Box
          component="img"
          src="/assets/images/logo.png"
          alt="Ministry of Health Logo"
          sx={{ width: "56px", height: "32px", objectFit: "cover" }}
        />
      </Box>
      <CustomDivider />
      <List>
        {PATH.MENU.map((menuItem) => (
          <ListItem
            sx={{
              "& .MuiListItemIcon-root": {
                color: (theme) => theme.palette.gray.main,
                minWidth: "40px",
              },
              ":hover": {
                backgroundColor: (theme) => theme.palette.primary.main,
                color: "#fff !important",
                "& .MuiListItemIcon-root, & .MuiListItemText-root": {
                  color: "#fff !important",
                },
              },
            }}
            onClick={(e) => {e.stopPropagation(); navigate(menuItem.path)}}
            key={menuItem.name}
            disablePadding
          >
           {/* <Link to={menuItem.path}> */}
            <ListItemButton>
              <ListItemIcon>
                {<menuItem.icon />}
              </ListItemIcon>
              <ListItemText primary={<strong>{menuItem.name}</strong>} />
            </ListItemButton>
            {/* </Link> */}
          </ListItem>
        ))}
      </List>
      <CustomDivider />
    </div>
  );

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{
            background: "#1C2536",
            boxShadow: "none",
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant="h1"
              color="white"
              fontWeight="bold"
              noWrap
              letterSpacing="2px"
              sx={{ flexGrow: 1, lineHeight: "40px" }}
              textAlign='center'
            >
              Ministry of Health
            </Typography>
            {auth && (
              <div>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                  sx={{
                    backgroundColor: (theme) => theme.palette.secondary.main,
                    ":hover":{
                      backgroundColor: (theme) => theme.palette.primary.main,
                    }
                  }}
                >
                  <AccountCircle />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem onClick={()=>{
                    handleClose();
                    handleLogout();
                    }}>Logout</MenuItem>
                </Menu>
              </div>
            )}
          </Toolbar>
        </AppBar>
        <Box
          component="nav"
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
          aria-label="mailbox folders"
        >
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onTransitionEnd={handleDrawerTransitionEnd}
            onClose={handleDrawerClose}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                background: (theme) => theme.palette.secondary.main,
                color: (theme) => theme.palette.gray.main,
              },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                background: (theme) => theme.palette.secondary.main,
                color: (theme) => theme.palette.gray.main,
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
          }}
        >
          <Toolbar />
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default MainLayout;
